/**
 * The DEV tab (hand-built test lawns): always there in dev builds (but not with `?storePreview`, for
 * App Store screenshots); in the hosted and store builds it opens with a secret (five taps in the
 * blank space at the bottom of Settings) and then stays on for this device. Kept out of the save:
 * it is a per-device convenience, not progress.
 */
const KEY = 'lm.devArea';

/** Registry key for the menu's current tab (shared by the menu and Settings). */
export const REG_MENU_MODE = 'menu.mode';

/** Opened this visit (still works when storage is blocked, e.g. a private window). */
let openThisVisit = false;

/** Dev only: `?storePreview`, the app as its store screenshots show it (pnpm store:shots). */
export const storePreview = (): boolean =>
  import.meta.env.DEV && new URLSearchParams(location.search).has('storePreview');

export function devAreaOpen(): boolean {
  if (openThisVisit) return true;
  if (import.meta.env.DEV) return !storePreview();
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function unlockDevArea(): void {
  openThisVisit = true;
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // Storage blocked: open for this visit only.
  }
}
